var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"layout"},[_c('h1',[_vm._v("/nope.")]),_c('p',[_vm._v("This address goes nowhere.")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to the thing →")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }